module.exports = __webpack_public_path__ + "static/filter-include-exclude-categories-1d0a65559ddd6b97901e1f0cee6aeff8.png";